import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import LineHeightOutlinedSvg from "@ant-design/icons-svg/es/asn/LineHeightOutlined";
import AntdIcon from "../components/AntdIcon";
var LineHeightOutlined = function LineHeightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LineHeightOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LineHeightOutlined.displayName = 'LineHeightOutlined';
}
export default /*#__PURE__*/React.forwardRef(LineHeightOutlined);